import React, { useState, useEffect } from "react";
import { Sidebar } from "../sidebar/Sidebar";
import { Navbar } from "../navbar/Navbar";
import axiosInstance from "../../api/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./projectParticularForm.scss";

const ProjectParticularForm = () => {
  const [formData, setFormData] = useState({
    studentId: localStorage.getItem("studentId") || "",
    mentorChanged: 0,
    title: "",
    thesisAbstract: "",
    keywords: "",
    mentorId1ReadyViva: "",
    mentorId2ReadyViva: "",
    immediateSupervisorName: "",
    immediateSupervisorContact: "",
    isLatest: true,

    instructor1: {
      name: "",
      email: "",
      phoneNumber: "",
      organization: "",
      totalWorkExperience: "",
      totalAIWorkExperience: "",
      linkedinProfile: "",
      cv: "",
    },
    instructor2: {
      name: "",
      email: "",
      phoneNumber: "",
      organization: "",
      totalWorkExperience: "",
      totalAIWorkExperience: "",
      linkedinProfile: "",
      cv: "",
    },
  });

  const [studentName, setStudentName] = useState("");
  useEffect(() => {
    const name = localStorage.getItem("username");
    if (name) setStudentName(name);
  }, []);

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("instructor1.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        instructor1: { ...prev.instructor1, [key]: value },
      }));
    } else if (name.startsWith("instructor2.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        instructor2: { ...prev.instructor2, [key]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { instructor1, instructor2, ...thesisFields } = formData;

    // ---------- Thesis compulsory fields ----------
    if (!formData.title.trim()) {
      toast.error("Project Title is required");
      return;
    }
    if (!formData.thesisAbstract.trim()) {
      toast.error("Project Abstract is required");
      return;
    }
    if (!formData.keywords.trim()) {
      toast.error("Keywords are required");
      return;
    }
    if (!formData.immediateSupervisorName.trim()) {
      toast.error("Immediate Supervisor Name is required");
      return;
    }
    if (!formData.immediateSupervisorContact.trim()) {
      toast.error("Immediate Supervisor Contact is required");
      return;
    }

    // ---------- Mentor 1 checks ----------
    if (!instructor1.name.trim()) {
      toast.error("Mentor 1 name is required");
      return;
    }
    if (!instructor1.email.trim()) {
      toast.error("Mentor 1 email is required");
      return;
    }
    if (!instructor1.organization.trim()) {
      toast.error("Mentor 1 company/organization is required");
      return;
    }
    if (!instructor1.totalWorkExperience.trim()) {
      toast.error("Mentor 1 total work experience is required");
      return;
    }
    if (!instructor1.totalAIWorkExperience.trim()) {
      toast.error("Mentor 1 total AI work experience is required");
      return;
    }

    // Mentor 1 must have LinkedIn or CV
    if (!instructor1.linkedinProfile.trim() && !instructor1.cv.trim()) {
      toast.error("Mentor 1 must have either LinkedIn profile or CV");
      return;
    }

    // ---------- Mentor 1 AI = 0 → Mentor 2 required ----------
    const aiExp1 = parseFloat(instructor1.totalAIWorkExperience || "0");
    if (aiExp1 === 0) {
      if (!instructor2.name.trim()) {
        toast.error("Mentor 2 name is required since Mentor 1 has 0 AI experience");
        return;
      }
      if (!instructor2.email.trim()) {
        toast.error("Mentor 2 email is required");
        return;
      }
      if (!instructor2.organization.trim()) {
        toast.error("Mentor 2 organization is required");
        return;
      }
      if (!instructor2.totalWorkExperience.trim()) {
        toast.error("Mentor 2 total work experience is required");
        return;
      }
      if (!instructor2.totalAIWorkExperience.trim()) {
        toast.error("Mentor 2 total AI work experience is required");
        return;
      }
      if (!instructor2.linkedinProfile.trim() && !instructor2.cv.trim()) {
        toast.error("Mentor 2 must have either LinkedIn profile or CV");
        return;
      }
    } else {
      // Optional Mentor 2 validation
      const mentor2HasData = Object.values(instructor2).some(
        (v) => typeof v === "string" && v.trim() !== ""
      );
      if (mentor2HasData) {
        if (!instructor2.name.trim()) {
          toast.error("Mentor 2 name is required");
          return;
        }
        if (!instructor2.email.trim()) {
          toast.error("Mentor 2 email is required");
          return;
        }
        if (!instructor2.organization.trim()) {
          toast.error("Mentor 2 organization is required");
          return;
        }
        if (!instructor2.linkedinProfile.trim() && !instructor2.cv.trim()) {
          toast.error("Mentor 2 must have either LinkedIn profile or CV");
          return;
        }
      }
    }

    // ---------- Payload (empty string for missing optional values) ----------
    const payload = {
      ...thesisFields,
      mentor1_name: instructor1.name || "",
      mentor1_email: instructor1.email || "",
      mentor1_phone_number: instructor1.phoneNumber || "",
      mentor1_organization: instructor1.organization || "",
      mentor1_total_work_experience: instructor1.totalWorkExperience || "",
      mentor1_total_ai_work_experience: instructor1.totalAIWorkExperience || "",
      mentor1_linkedin_profile: instructor1.linkedinProfile || "",
      mentor1_cv: instructor1.cv || "",

      mentor2_name: instructor2.name || "",
      mentor2_email: instructor2.email || "",
      mentor2_phone_number: instructor2.phoneNumber || "",
      mentor2_organization: instructor2.organization || "",
      mentor2_total_work_experience: instructor2.totalWorkExperience || "",
      mentor2_total_ai_work_experience: instructor2.totalAIWorkExperience || "",
      mentor2_linkedin_profile: instructor2.linkedinProfile || "",
      mentor2_cv: instructor2.cv || "",
    };

    try {
      await axiosInstance.post("/project-particular", payload);
      toast.success("Project Particular Saved!");
      navigate("/student");
    } catch (error) {
      console.error("Error saving project particulars:", error);
      toast.error("Error saving project particular");
    }
  };

  return (
    <div className="projectParticularForm">
      <Sidebar />
      <div className="mainContainer">
        <Navbar />
        <div className="formContainer">
          <h2>Project Particular Form</h2>
          <form onSubmit={handleSubmit}>
            <input type="text" value={studentName} readOnly />
            <input
              type="hidden"
              name="studentId"
              value={formData.studentId}
              readOnly
            />

            {/* Thesis fields */}
            <label>Project Title*</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              required
            />
            <label>Project Abstract - A 150 words brief*</label>
            <textarea
              name="thesisAbstract"
              value={formData.thesisAbstract}
              onChange={handleChange}
              required
            />
            <label>Keywords: Domain, AI/ML models and Approach*</label>
            <input
              type="text"
              name="keywords"
              value={formData.keywords}
              onChange={handleChange}
              required
            />
            <label>Immediate Supervisor : Name*</label>
            <input
              type="text"
              name="immediateSupervisorName"
              value={formData.immediateSupervisorName}
              onChange={handleChange}
              required
            />
            <label>Immediate Supervisor : Contact Details*</label>
            <input
              type="text"
              name="immediateSupervisorContact"
              value={formData.immediateSupervisorContact}
              onChange={handleChange}
              required
            />

            {/* Mentor 1 */}
            <h3>Mentor 1 Details</h3>
            <label>Name*</label>
            <input
              type="text"
              name="instructor1.name"
              value={formData.instructor1.name}
              onChange={handleChange}
              required
            />
            <label>Email*</label>
            <input
              type="email"
              name="instructor1.email"
              value={formData.instructor1.email}
              onChange={handleChange}
              required
            />
            <label>Phone Number*</label>
            <input
              type="text"
              name="instructor1.phoneNumber"
              value={formData.instructor1.phoneNumber}
              onChange={handleChange}
            />
            <label>Company*</label>
            <input
              type="text"
              name="instructor1.organization"
              value={formData.instructor1.organization}
              onChange={handleChange}
              required
            />
            <label>Experience (Years) in Problem Domain*</label>
            <input
              type="number"
              name="instructor1.totalWorkExperience"
              value={formData.instructor1.totalWorkExperience}
              onChange={handleChange}
              required
              min="0" // optional: ensures non-negative
              step="0.1"
            />
            <label>Experience (Years) in AI/ML Field*</label>
            <input
              type="number"
              name="instructor1.totalAIWorkExperience"
              value={formData.instructor1.totalAIWorkExperience}
              onChange={handleChange}
              required
              min="0" // optional: ensures non-negative
              step="0.1"
            />
            <label>LinkedIn Profile</label>
            <input
              type="text"
              name="instructor1.linkedinProfile"
              value={formData.instructor1.linkedinProfile}
              onChange={handleChange}
            />
            <label>CV Link</label>
            <input
              type="text"
              name="instructor1.cv"
              value={formData.instructor1.cv}
              onChange={handleChange}
            />
            <small style={{ color: "gray" }}>
              * Mentor 1 must have either LinkedIn or CV
            </small>

            <label>Is Mentor 1 Ready to attend the Viva ?*</label>
            <select
              name="mentorId1ReadyViva"
              value={formData.mentorId1ReadyViva || ""}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
              <option value="maybe">Maybe</option>
            </select>

            {/* Mentor 2 */}
            <h3>Mentor 2 Details (Required if Mentor 1 has experience either in problem domain or AI/ML field)</h3>
            <label>Name</label>
            <input
              type="text"
              name="instructor2.name"
              value={formData.instructor2.name}
              onChange={handleChange}
            />
            <label>Email</label>
            <input
              type="email"
              name="instructor2.email"
              value={formData.instructor2.email}
              onChange={handleChange}
            />
            <label>Phone Number</label>
            <input
              type="text"
              name="instructor2.phoneNumber"
              value={formData.instructor2.phoneNumber}
              onChange={handleChange}
            />
            <label>Company</label>
            <input
              type="text"
              name="instructor2.organization"
              value={formData.instructor2.organization}
              onChange={handleChange}
            />
            <label>Experience (Years) in Problem Domain</label>
            <input
              type="number"
              name="instructor2.totalWorkExperience"
              value={formData.instructor2.totalWorkExperience}
              onChange={handleChange}
              min="0" // optional: ensures non-negative
            />
            <label>Experience (Years) in AI/ML Field</label>
            <input
              type="number"
              name="instructor2.totalAIWorkExperience"
              value={formData.instructor2.totalAIWorkExperience}
              onChange={handleChange}
              min="0" // optional: ensures non-negative
            />
            <label>LinkedIn Profile</label>
            <input
              type="text"
              name="instructor2.linkedinProfile"
              value={formData.instructor2.linkedinProfile}
              onChange={handleChange}
            />
            <label>CV Link</label>
            <input
              type="text"
              name="instructor2.cv"
              value={formData.instructor2.cv}
              onChange={handleChange}
            />
            <small style={{ color: "gray" }}>
              * Mentor 2 must have either LinkedIn or CV if details are provided
            </small>

            <label>Is Mentor 2 Ready to attend the Viva ?</label>
            <select
              name="mentorId2ReadyViva"
              value={formData.mentorId2ReadyViva || ""}
              onChange={handleChange}
            >
              <option value="">-- Select --</option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
              <option value="maybe">Maybe</option>
            </select>

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProjectParticularForm;
